export default __webpack_public_path__ + "static/media/reactjs.238bdf4e.png";